import React from 'react';
export function ForWhomSection() {
  const yesList = ['You recognize the Pleasure → Guilt → Emptiness cycle in your own experience', 'You already tried willpower and it was not enough', 'You want concrete tools, not more information about the problem', 'You prefer to work on it privately, without public therapy or groups', 'You are willing to put in 5-15 minutes of real practice a day'];
  const noList = ['You are looking for a magic fix that requires no effort from you', 'You are not willing to be honest with yourself in the process', 'You need urgent clinical care — in that case, seek medical help first'];
  return <section className="py-6 md:py-8 px-5 bg-[radial-gradient(ellipse_at_right,rgba(194,0,111,0.12)_0%,transparent_60%),var(--dark-bg)]" data-id="element-53" data-mp="o960p5non3rx">
      <div className="max-w-[900px] mx-auto" data-id="element-54" data-mp="38wr6kmbmr0dh">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-55" data-mp="38z53l0pvemno">
          Is this for you?
        </span>
        <h2 className="text-[clamp(1.8rem,4vw,2.8rem)] font-heading font-black leading-[1.2] mb-3" data-id="element-56" data-mp="34styiooz86bz">
          This is for you if...
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-57" data-mp="3dspct2dtwhg8">
          {/* Yes Card */}
          <div className="rounded-2xl p-5 bg-[rgba(0,207,255,0.05)] border border-[rgba(0,207,255,0.3)]" data-id="element-58" data-mp="38tm7rhxumb89">
            <h3 className="text-[1.2rem] font-heading font-bold text-blue-light mb-3" data-id="element-59" data-mp="3nqwp37x6abbw">
              ✅ Yes, it is for you
            </h3>
            <ul className="list-none space-y-0" data-id="element-60" data-mp="3iqqtjgns84oj">
              {yesList.map((item, idx) => <li key={idx} className="flex items-start gap-3 py-2 border-b border-white/5 last:border-b-0 text-[0.95rem] text-white/80 leading-[1.5]" data-id="element-61" data-mp="crfeweog98f" data-mpi={idx}>
                  <span className="text-[1.1rem] shrink-0 mt-[2px]" data-id="element-62" data-mp="acs3swrelfjh">✓</span>
                  <span data-id="element-63" data-mp="5dow14k1gv7t">{item}</span>
                </li>)}
            </ul>
          </div>
          {/* No Card */}
          <div className="rounded-2xl p-5 bg-[rgba(194,0,111,0.05)] border border-[rgba(194,0,111,0.2)]" data-id="element-64" data-mp="2z6gg0ubtj3e3">
            <h3 className="text-[1.2rem] font-heading font-bold text-magenta-bright mb-3" data-id="element-65" data-mp="336qlm5vp7rsf">
              ❌ Not for you if
            </h3>
            <ul className="list-none space-y-0" data-id="element-66" data-mp="3cw0dplqjlagj">
              {noList.map((item, idx) => <li key={idx} className="flex items-start gap-3 py-2 border-b border-white/5 last:border-b-0 text-[0.95rem] text-white/80 leading-[1.5]" data-id="element-67" data-mp="3hvdb30f1hzxd" data-mpi={idx}>
                  <span className="text-[1.1rem] shrink-0 mt-[2px] text-magenta-bright" data-id="element-68" data-mp="3qwb7oxn5f55x">
                    ✗
                  </span>
                  <span data-id="element-69" data-mp="3vtuw2qdk8ybl">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}